export type SiteVariant = 'watchi' | 'dialify';

export const SITE_VARIANT: SiteVariant =
  process.env.REACT_APP_SITE_VARIANT === 'dialify' ? 'dialify' : 'watchi';

export const IS_DIALIFY = SITE_VARIANT === 'dialify';
